import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _BuildingButtons;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@instructure/ui-buttons';
import { Menu } from '@instructure/ui-menu';
import { IconExportLine, IconMoreSolid, IconImportLine, IconBankLine, IconPrinterLine, IconSpeedGraderLine } from '@instructure/ui-icons';
import { View } from '@instructure/ui-view';
import { Drilldown } from '@instructure/ui-drilldown';
import { TopNavBar } from '@instructure/ui-top-nav-bar';
import PrintTrigger from '../../../../../common/components/shared/PrintTrigger';
import { PRINT_CURRENT_PAGE, PRINT_BLANK, withStyleOverrides } from '@instructure/quiz-common';
import { jsx } from '@instructure/emotion';
import t from '@instructure/quiz-i18n/format-message';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var BuildingButtons = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_BuildingButtons = /*#__PURE__*/function (_Component) {
  function BuildingButtons() {
    var _this2;
    _classCallCheck(this, BuildingButtons);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, BuildingButtons, [].concat(args));
    _defineProperty(_this2, "quizExportAlert", function () {
      _this2.props.addInfo(t("The export process has been started. This can take a while for larger quizzes.\n      You can leave the page and you'll get notified when the export is completed."));
    });
    _defineProperty(_this2, "openBanksTray", function () {
      _this2.props.setBanksTrayButtonRef(_this2.banksTrayButton);
      _this2.props.openBanksTray();
    });
    _defineProperty(_this2, "openSpeedgraderLink", function () {
      window.open(_this2.props.speedgraderLink, '_blank');
    });
    _defineProperty(_this2, "startQuizExportJob", function () {
      if (_this2.props.canExport) {
        var _this2$props = _this2.props,
          activeQuizId = _this2$props.activeQuizId,
          contextUuid = _this2$props.contextUuid;
        var exportSettings = {
          export_type: 'qti',
          everything: false,
          quizzes: [activeQuizId]
        };
        _this2.quizExportAlert();
        _this2.props.contentExport({
          contextUuid: contextUuid,
          exportSettings: exportSettings
        }, _this2.props.addAlert);
        _this2.props.startExport(activeQuizId);
      }
    });
    return _this2;
  }
  _inherits(BuildingButtons, _Component);
  return _createClass(BuildingButtons, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.makeStyles();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.props.makeStyles();
    }
  }, {
    key: "renderSavingMessage",
    value: function renderSavingMessage() {
      if (this.props.quizSaving) {
        return jsx("div", {
          css: this.props.styles.quizSaving
        }, t('Saving...'));
      }
    }
  }, {
    key: "isBuildingPage",
    value: function isBuildingPage() {
      return 'building' === this.props.app;
    }
  }, {
    key: "renderSpeedGraderButton",
    value: function renderSpeedGraderButton() {
      var key = 'speedgrader';
      var text = t('Speedgrader');
      if (this.props.iceTopNavBarEnabled) {
        return jsx(Drilldown.Option, {
          id: key,
          key: key,
          onOptionClick: this.openSpeedgraderLink
        }, jsx(IconSpeedGraderLine, null), jsx(View, {
          as: "span",
          margin: "0 0 0 x-small"
        }, text));
      }
      return jsx(Menu.Item, {
        key: key,
        onSelect: this.openSpeedgraderLink
      }, jsx(IconSpeedGraderLine, {
        css: this.props.styles.menuIcon
      }), text);
    }
  }, {
    key: "renderImportContentButton",
    value: function renderImportContentButton() {
      var key = 'import';
      var text = t('Import Content');
      var onClick = this.props.openModal;
      var disabled = !this.props.canImport;
      var menuItemDataAutomation = 'sdk-import-content-menuitem';
      var iconDataAutomation = 'sdk-import-content-icon';
      if (this.props.iceTopNavBarEnabled) {
        return jsx(Drilldown.Option, {
          id: key,
          key: key,
          disabled: disabled,
          onOptionClick: onClick,
          "data-automation": menuItemDataAutomation
        }, jsx(IconImportLine, {
          "data-automation": iconDataAutomation
        }), jsx(View, {
          as: "span",
          margin: "0 0 0 x-small"
        }, text));
      }
      return jsx(Menu.Item, {
        key: key,
        disabled: disabled,
        onSelect: onClick,
        "data-automation": menuItemDataAutomation
      }, jsx(IconImportLine, {
        css: this.props.styles.menuIcon,
        "data-automation": iconDataAutomation
      }), text);
    }
  }, {
    key: "renderContentExportButton",
    value: function renderContentExportButton() {
      var key = 'export';
      var text = t('Export Content');
      var onClick = this.startQuizExportJob;
      var disabled = !this.props.canExport;
      var menuItemDataAutomation = 'sdk-export-content-menuitem';
      var iconDataAutomation = 'sdk-export-content-icon';
      if (this.props.iceTopNavBarEnabled) {
        return jsx(Drilldown.Option, {
          id: key,
          key: key,
          disabled: disabled,
          onOptionClick: onClick,
          "data-automation": menuItemDataAutomation
        }, jsx(IconExportLine, {
          "data-automation": iconDataAutomation
        }), jsx(View, {
          as: "span",
          margin: "0 0 0 x-small"
        }, text));
      }
      return jsx(Menu.Item, {
        key: key,
        disabled: disabled,
        onSelect: onClick,
        "data-automation": menuItemDataAutomation
      }, jsx(IconExportLine, {
        css: this.props.styles.menuIcon,
        "data-automation": iconDataAutomation
      }), text);
    }
  }, {
    key: "renderManageItemBanksButton",
    value: function renderManageItemBanksButton() {
      var key = 'banks';
      var text = t('Manage Item Banks');
      var onClick = this.props.navigateToBanks;
      var menuItemDataAutomation = 'sdk-manage-item-banks-menuitem';
      var iconDataAutomation = 'sdk-manage-item-banks-icon';
      if (this.props.iceTopNavBarEnabled) {
        return jsx(Drilldown.Option, {
          id: key,
          key: key,
          onOptionClick: onClick,
          "data-automation": menuItemDataAutomation
        }, jsx(IconBankLine, {
          "data-automation": iconDataAutomation
        }), jsx(View, {
          as: "span",
          margin: "0 0 0 x-small"
        }, text));
      }
      return jsx(Menu.Item, {
        key: key,
        onSelect: onClick,
        "data-automation": menuItemDataAutomation
      }, jsx(IconBankLine, {
        css: this.props.styles.menuIcon,
        "data-automation": iconDataAutomation
      }), text);
    }
  }, {
    key: "renderPrintKeyButton",
    value: function renderPrintKeyButton(handlePrint) {
      var key = 'printKey';
      var text = t('Print Key (With Answers)');
      var onClick = function onClick() {
        return handlePrint(PRINT_CURRENT_PAGE);
      };
      var disabled = !this.props.hasQuestions || this.props.isEditing;
      var menuItemDataAutomation = 'sdk-print-key-menuitem';
      var iconDataAutomation = 'sdk-print-icon';
      if (this.props.iceTopNavBarEnabled) {
        return jsx(Drilldown.Option, {
          id: key,
          key: key,
          disabled: disabled,
          onOptionClick: onClick,
          "data-automation": menuItemDataAutomation
        }, jsx(IconPrinterLine, {
          "data-automation": iconDataAutomation
        }), jsx(View, {
          as: "span",
          margin: "0 0 0 x-small"
        }, text));
      }
      return jsx(Menu.Item, {
        key: key,
        disabled: disabled,
        onSelect: onClick,
        "data-automation": menuItemDataAutomation
      }, jsx(IconPrinterLine, {
        css: this.props.styles.menuIcon,
        "data-automation": iconDataAutomation
      }), text);
    }
  }, {
    key: "renderPrintBlankButton",
    value: function renderPrintBlankButton(handlePrint) {
      var key = 'printBlank';
      var text = t('Print Blank Quiz');
      var onClick = function onClick() {
        return handlePrint(PRINT_BLANK);
      };
      var disabled = !this.props.hasQuestions || this.props.isEditing;
      var menuItemDataAutomation = 'sdk-print-blank-menuitem';
      var iconDataAutomation = 'sdk-print-blank-icon';
      if (this.props.iceTopNavBarEnabled) {
        return jsx(Drilldown.Option, {
          id: key,
          key: key,
          disabled: disabled,
          onOptionClick: onClick,
          "data-automation": menuItemDataAutomation
        }, jsx(IconPrinterLine, {
          "data-automation": iconDataAutomation
        }), jsx(View, {
          as: "span",
          margin: "0 0 0 x-small"
        }, text));
      }
      return jsx(Menu.Item, {
        key: key,
        disabled: disabled,
        onSelect: onClick,
        "data-automation": menuItemDataAutomation
      }, jsx(IconPrinterLine, {
        css: this.props.styles.menuIcon,
        "data-automation": iconDataAutomation
      }), text);
    }
  }, {
    key: "renderMenu",
    value: function renderMenu(handlePrint) {
      if (!this.isBuildingPage()) return;
      var menuItems = [];
      if (this.props.speedgraderLink) {
        menuItems.push(this.renderSpeedGraderButton());
      }
      menuItems.push(this.renderImportContentButton());
      if (this.props.contentExportEnabled) {
        menuItems.push(this.renderContentExportButton());
      }
      if (this.props.enableItemBanking) {
        menuItems.push(this.renderManageItemBanksButton());
      }
      if (this.props.printingEnabled) {
        menuItems.push(this.renderPrintKeyButton(handlePrint));
        menuItems.push(this.renderPrintBlankButton(handlePrint));
      }
      if (menuItems.length < 1) return;
      if (this.props.iceTopNavBarEnabled) {
        return jsx(TopNavBar.Item, {
          id: this.props.id,
          variant: "icon",
          renderIcon: this.props.renderIcon,
          showSubmenuChevron: false,
          renderSubmenu: jsx(Drilldown, {
            rootPageId: "root"
          }, jsx(Drilldown.Page, {
            id: "root"
          }, menuItems))
        }, t('More'));
      }
      return jsx(Menu, {
        trigger: jsx(IconButton, {
          renderIcon: IconMoreSolid,
          withBackground: false,
          withBorder: false,
          "data-automation": "sdk-more-quiz-actions-button",
          screenReaderLabel: t('More Quiz Actions')
        })
      }, menuItems);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      return jsx("div", {
        css: this.props.styles.buttonsHolder
      }, this.renderSavingMessage(), jsx(PrintTrigger, {
        render: function render(handlePrint) {
          return _this3.renderMenu(handlePrint);
        },
        navigateToPreviewPrint: this.props.navigateToPreviewPrint
      }));
    }
  }]);
}(Component), _defineProperty(_BuildingButtons, "displayName", 'BuildingButtons'), _defineProperty(_BuildingButtons, "componentId", "Quizzes".concat(_BuildingButtons.displayName)), _defineProperty(_BuildingButtons, "propTypes", {
  app: PropTypes.string,
  addAlert: PropTypes.func.isRequired,
  addInfo: PropTypes.func,
  activeQuizId: PropTypes.string,
  canExport: PropTypes.bool.isRequired,
  canImport: PropTypes.bool.isRequired,
  contentExportEnabled: PropTypes.bool,
  contentExport: PropTypes.func,
  enableItemBanking: PropTypes.bool,
  hasQuestions: PropTypes.bool.isRequired,
  isEditing: PropTypes.bool.isRequired,
  navigateToBanks: PropTypes.func.isRequired,
  navigateToPreviewPrint: PropTypes.func.isRequired,
  openBanksTray: PropTypes.func.isRequired,
  openModal: PropTypes.func.isRequired,
  printingEnabled: PropTypes.bool.isRequired,
  quizSaving: PropTypes.bool,
  setBanksTrayButtonRef: PropTypes.func.isRequired,
  speedgraderLink: PropTypes.string,
  startExport: PropTypes.func.isRequired,
  contextUuid: PropTypes.string,
  iceTopNavBarEnabled: PropTypes.bool,
  id: PropTypes.string,
  renderIcon: PropTypes.element,
  makeStyles: PropTypes.func,
  styles: PropTypes.object
}), _defineProperty(_BuildingButtons, "defaultProps", {
  activeQuizId: null,
  addInfo: function addInfo() {},
  app: null,
  contentExportEnabled: false,
  contentExport: null,
  enableItemBanking: true,
  quizSaving: false,
  speedgraderLink: null,
  contextUuid: null,
  iceTopNavBarEnabled: false,
  id: 'MoreButton',
  renderIcon: jsx(IconMoreSolid, null)
}), _BuildingButtons)) || _class);
export default BuildingButtons;